/**
 * unifiedSearchScreenStyles.js — StyleSheet for UnifiedSearchScreen.
 * Extracted verbatim from screens/UnifiedSearchScreen.jsx (god-file decomposition).
 */

import { Platform, StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#000000',
    },
    content: {
        flex: 1,
        padding: 20,
    },
    searchSection: {
        marginBottom: 30,
    },
    sectionTitle: {
        fontSize: 24,
        fontWeight: '700',
        color: '#FFFFFF',
        marginBottom: 20,
        fontFamily: 'ClimateCrisis',
    },
    controlRow: {
        flexDirection: 'row',
        gap: 15,
        marginBottom: 15,
    },
    controlGroup: {
        flex: 1,
    },
    controlLabel: {
        fontSize: 14,
        fontWeight: '600',
        color: 'rgba(255,255,255,0.8)',
        marginBottom: 8,
    },
    searchQueryContainer: {
        marginBottom: 15,
    },
    searchInput: {
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderRadius: 8,
        padding: 12,
        color: '#FFFFFF',
        fontSize: 16,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.2)',
    },
    advancedToggle: {
        alignSelf: 'flex-start',
        paddingVertical: 8,
        paddingHorizontal: 12,
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderRadius: 6,
        marginBottom: 15,
    },
    advancedToggleHovered: {
        backgroundColor: 'rgba(255,255,255,0.18)',
    },
    advancedToggleText: {
        color: '#FFFFFF',
        fontSize: 14,
        fontWeight: '600',
    },
    advancedPanel: {
        backgroundColor: 'rgba(255,255,255,0.05)',
        borderRadius: 12,
        padding: 20,
        marginBottom: 20,
    },
    advancedTitle: {
        fontSize: 18,
        fontWeight: '700',
        color: '#FFFFFF',
        marginBottom: 15,
    },
    advancedSection: {
        marginBottom: 20,
    },
    advancedSectionTitle: {
        fontSize: 16,
        fontWeight: '600',
        color: 'rgba(255,255,255,0.9)',
        marginBottom: 10,
    },
    rangeRow: {
        flexDirection: 'row',
        gap: 20,
    },
    rangeGroup: {
        flex: 1,
    },
    rangeLabel: {
        fontSize: 14,
        fontWeight: '500',
        color: 'rgba(255,255,255,0.8)',
        marginBottom: 8,
    },
    rangeInputs: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
    },
    rangeInput: {
        flex: 1,
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderRadius: 6,
        padding: 8,
        color: '#FFFFFF',
        fontSize: 14,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.2)',
    },
    rangeSeparator: {
        color: 'rgba(255,255,255,0.6)',
        fontSize: 14,
    },
    checkboxRow: {
        flexDirection: 'row',
        gap: 20,
    },
    checkbox: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 8,
        paddingHorizontal: 12,
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderRadius: 6,
    },
    checkboxActive: {
        backgroundColor: 'rgba(139, 92, 246, 0.3)',
        borderWidth: 1,
        borderColor: '#8b5cf6',
    },
    checkboxHovered: {
        backgroundColor: 'rgba(255,255,255,0.18)',
    },
    checkboxText: {
        color: 'rgba(255,255,255,0.8)',
        fontSize: 14,
        fontWeight: '500',
    },
    checkboxTextActive: {
        color: '#FFFFFF',
    },
    actionButtons: {
        flexDirection: 'row',
        gap: 15,
        marginTop: 20,
    },
    searchButton: {
        flex: 1,
    },
    clearButton: {
        paddingVertical: 12,
        paddingHorizontal: 20,
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'center',
    },
    clearButtonHovered: {
        backgroundColor: 'rgba(255,255,255,0.18)',
    },
    clearButtonText: {
        color: 'rgba(255,255,255,0.8)',
        fontSize: 16,
        fontWeight: '600',
    },
    resultsSection: {
        marginTop: 20,
    },
    resultsHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 15,
    },
    resultsTitle: {
        fontSize: 20,
        fontWeight: '700',
        color: '#FFFFFF',
    },
    resultsSubtitle: {
        fontSize: 14,
        color: 'rgba(255,255,255,0.6)',
    },
    sportsbookCountBadge: {
        fontSize: 14,
        fontWeight: '500',
        color: '#10b981', // Green to highlight the good coverage
    },
    resultsTable: {
        backgroundColor: 'rgba(255,255,255,0.05)',
        borderRadius: 12,
        overflow: 'hidden',
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: 'rgba(255,255,255,0.1)',
        paddingVertical: 12,
        paddingHorizontal: 8,
    },
    headerCell: {
        flex: 1,
        fontSize: 12,
        fontWeight: '700',
        color: '#FFFFFF',
        textAlign: 'center',
    },
    tableRow: {
        flexDirection: 'row',
        paddingVertical: 10,
        paddingHorizontal: 8,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(255,255,255,0.1)',
    },
    tableRowEven: {
        backgroundColor: 'rgba(255,255,255,0.02)',
    },
    tableRowHovered: {
        backgroundColor: 'rgba(162,89,255,0.08)',
    },
    tableCell: {
        flex: 1,
        fontSize: 11,
        color: 'rgba(255,255,255,0.9)',
        textAlign: 'center',
    },
    positiveValue: {
        color: '#4ade80',
        fontWeight: '600',
    },
    negativeValue: {
        color: '#f87171',
    },
    goodBookCount: {
        color: '#4ade80',
        fontWeight: '600',
    },
    lowBookCount: {
        color: '#fbbf24',
        fontWeight: '600',
    },
    // ⭐ Main vs Alt line badges
    mainAltBadge: {
        paddingHorizontal: 6,
        paddingVertical: 2,
        borderRadius: 4,
        marginLeft: 8,
    },
    mainBadge: {
        backgroundColor: 'rgba(34, 197, 94, 0.2)',
        borderWidth: 1,
        borderColor: 'rgba(34, 197, 94, 0.5)',
    },
    altBadge: {
        backgroundColor: 'rgba(251, 191, 36, 0.2)',
        borderWidth: 1,
        borderColor: 'rgba(251, 191, 36, 0.5)',
    },
    mainAltBadgeText: {
        fontSize: 9,
        fontWeight: '700',
        color: '#fff',
        letterSpacing: 0.5,
    },
    // 🏥 Injury badge in results table
    injuryBadgeSmall: {
        paddingHorizontal: 5,
        paddingVertical: 2,
        borderRadius: 3,
        backgroundColor: 'rgba(251, 191, 36, 0.2)',
        borderWidth: 1,
        borderColor: 'rgba(251, 191, 36, 0.5)',
    },
    injuryBadgeSmallOut: {
        backgroundColor: 'rgba(239, 68, 68, 0.2)',
        borderColor: 'rgba(239, 68, 68, 0.6)',
    },
    injuryBadgeSmallDoubtful: {
        backgroundColor: 'rgba(239, 68, 68, 0.15)',
        borderColor: 'rgba(239, 68, 68, 0.4)',
    },
    injuryBadgeSmallText: {
        fontSize: 8,
        fontWeight: '700',
        color: '#fff',
        letterSpacing: 0.3,
    },
    pagination: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 20,
        marginTop: 20,
    },
    paginationButton: {
        paddingVertical: 8,
        paddingHorizontal: 16,
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderRadius: 6,
    },
    paginationButtonHovered: {
        backgroundColor: 'rgba(255,255,255,0.18)',
    },
    paginationButtonDisabled: {
        opacity: 0.3,
    },
    paginationButtonText: {
        color: '#FFFFFF',
        fontSize: 14,
        fontWeight: '600',
    },
    paginationText: {
        color: 'rgba(255,255,255,0.8)',
        fontSize: 14,
    },
    selectCell: {
        width: 60,
        alignItems: 'center',
        justifyContent: 'center',
    },
    selectCheckbox: {
        width: 24,
        height: 24,
        borderRadius: 4,
        borderWidth: 2,
        borderColor: 'rgba(255,255,255,0.3)',
        alignItems: 'center',
        justifyContent: 'center',
    },
    selectCheckboxActive: {
        backgroundColor: '#8b5cf6',
        borderColor: '#8b5cf6',
    },
    selectCheckboxHovered: {
        borderColor: 'rgba(139,92,246,0.6)',
        backgroundColor: 'rgba(139,92,246,0.15)',
    },
    checkmark: {
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: '700',
    },
    sgpBuilderSection: {
        marginTop: 20,
        alignItems: 'center',
    },
    sgpBuilderButton: {
        minWidth: 250,
    },
    kellyButtonsRow: {
        flexDirection: 'row',
        gap: 8,
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    kellyPresetButton: {
        paddingVertical: 6,
        paddingHorizontal: 10,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.18)',
        backgroundColor: 'rgba(255,255,255,0.05)',
    },
    kellyPresetButtonActive: {
        backgroundColor: 'rgba(162, 89, 255, 0.4)',
        borderColor: '#A259FF',
    },
    kellyPresetButtonHovered: {
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderColor: 'rgba(255,255,255,0.3)',
    },
    kellyPresetText: {
        color: 'rgba(255,255,255,0.7)',
        fontWeight: '400',
        fontSize: 13,
    },
    kellyPresetTextActive: {
        color: '#FFFFFF',
        fontWeight: '700',
    },
    kellyCustomInput: {
        color: '#FFFFFF',
        fontSize: 13,
        paddingVertical: 6,
        paddingHorizontal: 10,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.18)',
        backgroundColor: 'rgba(255,255,255,0.05)',
        minWidth: 60,
    },
    kellyHint: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 11,
        marginTop: 4,
        fontStyle: 'italic',
    },
    activeFiltersSection: {
        marginTop: 16,
        padding: 12,
        backgroundColor: 'rgba(139, 92, 246, 0.1)',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(139, 92, 246, 0.3)',
    },
    activeFiltersLabel: {
        color: '#a78bfa',
        fontSize: 13,
        fontWeight: '600',
        marginBottom: 8,
    },
    activeFiltersChips: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 6,
        marginBottom: 8,
    },
    activeFilterChip: {
        paddingVertical: 4,
        paddingHorizontal: 8,
        backgroundColor: 'rgba(139, 92, 246, 0.2)',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: 'rgba(139, 92, 246, 0.4)',
    },
    activeFilterChipText: {
        color: '#c4b5fd',
        fontSize: 11,
        fontWeight: '600',
    },
    activeFiltersHint: {
        color: 'rgba(196, 181, 253, 0.7)',
        fontSize: 10,
        fontStyle: 'italic',
    },
    cacheStatusContainer: {
        marginTop: 16,
        marginBottom: 8,
        padding: 14,
        backgroundColor: 'rgba(139, 92, 246, 0.1)',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(139, 92, 246, 0.3)',
    },
    cacheStatusHighlight: {
        backgroundColor: 'rgba(251, 191, 36, 0.15)',
        borderColor: 'rgba(251, 191, 36, 0.4)',
    },
    cacheStatusText: {
        color: '#c4b5fd',
        fontSize: 13,
        fontWeight: '500',
        textAlign: 'center',
        lineHeight: 18,
    },
    // Sportsbooks Multi-Select Styles
    sportsbooksSelector: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderRadius: 8,
        padding: 12,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.2)',
    },
    sportsbooksSelectorHovered: {
        backgroundColor: 'rgba(255,255,255,0.16)',
        borderColor: 'rgba(255,255,255,0.35)',
    },
    sportsbooksSelectorText: {
        color: 'rgba(255,255,255,0.8)',
        fontSize: 14,
        flex: 1,
    },
    sportsbooksArrow: {
        color: 'rgba(255,255,255,0.6)',
        fontSize: 12,
        marginLeft: 8,
    },
    sportsbooksDropdown: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: '#1a1a1a',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.2)',
        marginTop: 4,
        zIndex: 1000,
        maxHeight: 400,
        overflow: 'hidden',
        ...(Platform.OS === 'web' && {
            boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
        }),
    },
    sportsbooksDropdownHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        padding: 12,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(255,255,255,0.1)',
        backgroundColor: 'rgba(255,255,255,0.05)',
    },
    sportsbooksQuickAction: {
        paddingVertical: 6,
        paddingHorizontal: 12,
        backgroundColor: 'rgba(139,92,246,0.2)',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(139,92,246,0.4)',
    },
    sportsbooksQuickActionHovered: {
        backgroundColor: 'rgba(139,92,246,0.35)',
        borderColor: 'rgba(139,92,246,0.6)',
    },
    sportsbooksQuickActionText: {
        color: '#a78bfa',
        fontSize: 12,
        fontWeight: '600',
    },
    sportsbooksCloseBtn: {
        marginLeft: 'auto',
        paddingVertical: 6,
        paddingHorizontal: 12,
        backgroundColor: 'rgba(74,222,128,0.2)',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(74,222,128,0.4)',
    },
    sportsbooksCloseBtnHovered: {
        backgroundColor: 'rgba(74,222,128,0.35)',
        borderColor: 'rgba(74,222,128,0.65)',
    },
    sportsbooksCloseBtnText: {
        color: '#4ade80',
        fontSize: 12,
        fontWeight: '600',
    },
    sportsbooksList: {
        padding: 12,
        maxHeight: 320,
        overflow: 'scroll',
    },
    sportsbooksTierLabel: {
        color: 'rgba(255,255,255,0.5)',
        fontSize: 11,
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        marginTop: 12,
        marginBottom: 8,
    },
    sportsbooksGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 6,
    },
    sportsbookChip: {
        paddingVertical: 6,
        paddingHorizontal: 10,
        backgroundColor: 'rgba(255,255,255,0.08)',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(255,255,255,0.15)',
    },
    sportsbookChipSelected: {
        backgroundColor: 'rgba(139,92,246,0.3)',
        borderColor: '#8b5cf6',
    },
    sportsbookChipHovered: {
        backgroundColor: 'rgba(255,255,255,0.15)',
        borderColor: 'rgba(255,255,255,0.3)',
    },
    sportsbookChipText: {
        color: 'rgba(255,255,255,0.7)',
        fontSize: 12,
        fontWeight: '500',
    },
    sportsbookChipTextSelected: {
        color: '#FFFFFF',
        fontWeight: '600',
    },
    // Selected Sportsbooks Summary Section
    selectedSportsbooksSection: {
        marginTop: 12,
        padding: 12,
        backgroundColor: 'rgba(139,92,246,0.1)',
        borderRadius: 8,
        borderWidth: 1,
        borderColor: 'rgba(139,92,246,0.3)',
    },
    selectedSportsbooksHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 8,
    },
    selectedSportsbooksLabel: {
        color: '#a78bfa',
        fontSize: 13,
        fontWeight: '600',
    },
    clearSportsbooksBtn: {
        color: '#f87171',
        fontSize: 12,
        fontWeight: '600',
    },
    selectedSportsbooksChips: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 6,
    },
    selectedSportsbookChip: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        paddingVertical: 4,
        paddingLeft: 8,
        paddingRight: 6,
        backgroundColor: 'rgba(139,92,246,0.25)',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: 'rgba(139,92,246,0.5)',
    },
    selectedSportsbookChipHovered: {
        backgroundColor: 'rgba(248,113,113,0.2)',
        borderColor: 'rgba(248,113,113,0.5)',
    },
    selectedSportsbookChipText: {
        color: '#c4b5fd',
        fontSize: 11,
        fontWeight: '600',
    },
    selectedSportsbookRemove: {
        color: 'rgba(196,181,253,0.7)',
        fontSize: 14,
        fontWeight: '600',
    },
});
